/* asiri-force-grid.js v2
   Fuerza CUADRICULA de 2 columnas SOLO en la pagina de listado de
   productos de una coleccion/categoria (56 productos, etc).
   FIX v2: el selector anterior ".collection ul.product-grid" era
   demasiado amplio y tambien atrapaba a Coleccion Destacada y
   Productos Destacados en portada (esas secciones tambien usan
   class="collection" + ul.product-grid), rompiendo su carrusel.
   Ahora se limita EXCLUSIVAMENTE al ul con id="product-grid", que
   solo existe en la pagina de listado (main-collection-product-grid),
   nunca en los carruseles de portada (esos usan id="Slider-{id}"). */
(function () {
  'use strict';

  function applyGrid() {
    if (window.innerWidth > 749) return;

    var grids = document.querySelectorAll('ul#product-grid');

    grids.forEach(function (ul) {
      ul.style.setProperty('display', 'grid', 'important');
      ul.style.setProperty('grid-template-columns', 'repeat(2, 1fr)', 'important');
      ul.style.setProperty('column-gap', '10px', 'important');
      ul.style.setProperty('row-gap', '18px', 'important');
      ul.style.setProperty('flex-wrap', 'unset', 'important');

      var items = ul.querySelectorAll(':scope > li');
      items.forEach(function (li) {
        li.style.setProperty('width', '100%', 'important');
        li.style.setProperty('max-width', '100%', 'important');
        li.style.setProperty('min-width', '0', 'important');
        li.style.setProperty('flex', 'none', 'important');
        li.style.setProperty('margin', '0', 'important');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyGrid);
  } else {
    applyGrid();
  }
  window.addEventListener('load', applyGrid);
  window.addEventListener('resize', applyGrid);
  window.addEventListener('pageshow', applyGrid);
  setTimeout(applyGrid, 300);
  setTimeout(applyGrid, 1000);
  setTimeout(applyGrid, 2000);

  var target = document.getElementById('product-grid');
  if (target && window.MutationObserver) {
    var mo = new MutationObserver(function () {
      applyGrid();
    });
    mo.observe(target, { childList: true, subtree: true });
  }
})();
